module.exports = __webpack_public_path__ + "static/media/technology.0b5f2f20.jpg";